export default "__VITE_ASSET__31g26xfd__"